export const CAPABILITY = {
    AMZL_CORE: "AMZL_CORE",
    AR_NEXT_GEN: "AR_NEXT_GEN"
}

export const DARK_MODE = {
    DARK: "dark",
    LIGHT: "light"
}

export const HOUR_MILLISECONDS = 3600000;
export const EMPTY_STRING = ""
export const TOTAL_STRING = "Total"
export const TIMEOUT_STRING = "timeout"
export const NEWLINE_CHAR   = "\n"

export const FEATURES = {
    ASL_LEGACY_PROTOCOL: "isASLLegacyProtocol",
    IS_CPT_FILTER_ENABLED: "isCPTFilterEnabled",
    IS_AUTO_FORCE_INDUCT_ENABLED: "isAutoForceInductEnabled",
    IS_INDUCT_MANAGEMENT_TAB_PERMISSIONS_ENABLED: "isInductManagementTabPermissionsEnabled",
    IS_UNLOADING_SEQUENCE_FLOW_ENABLED: "isUnloadingSequenceFlowEnabled",
    IS_PARALLEL_STAG_ENABLED: "isParallelSTAGEnabled",
    IS_ASSOCIATE_SCAN_METRIC_ENABLED: "isAssociateScanMetricEnabled",
    IS_INDUCT_CONFIGURATION_ENABLED: "isInductConfigurationEnabled",
    IS_PRIORITY_LANE_COUNT_ENABLED: "isPriorityLaneCountEnabled",
    IS_QUALITY_METRICS_ENABLED: "isQualityMetricsEnabled",
    IS_CONTINUOUS_SORTATION_ENABLED: "isContinuousSortationEnabled",
    IS_CUBE_METRICS_ENABLED: "isCubeMetricsEnabled",
    // Remote config (AppConfig/g2s2/SDC) holding, per station, the set of cycles for which
    // specific force-induct statuses (e.g. ENABLED) must be hidden from the dropdown.
    FORCE_INDUCT_RESTRICTED_STATUS_CONFIG: "forceInductRestrictedStatusConfig"
}

export const ACTION_TYPE = {
    GET_FEATURES_STATUS: "GET_FEATURES_STATUS",
    GET_FORCE_INDUCT_RESTRICTED_STATUS_CONFIG: "GET_FORCE_INDUCT_RESTRICTED_STATUS_CONFIG"
}

export const MARKETPLACE_LOCALE_MAP = {
    de: ["de", "de-DE", "de-CH", "de-AT", "de-LU", "de-LI"],
    es: ["es", "es-ES", "es-AR", "es-GT", "es-CR", "es-PA", "es-DO", "es-MX", "es-VE", "es-CO",
        "es-PE", "es-EC", "es-CL", "es-UY", "es-PY", "es-BO", "es-SV", "es-HN", "es-NI", "es-PR"],
    ja: ["ja", "ja-JP"],
    tr: ["tr", "tr-TR"],
    it: ["it", "it-IT", "it-CH"],
    fr: ["fr", "fr-FR", "fr-BE", "fr-CA", "fr-CH", "fr-LU"],
    ar: ["ar", "ar-SA", "ar-IQ", "ar-EG", "ar-LY", "ar-DZ", "ar-MA", "ar-TN", "ar-OM", "ar-YE",
        "ar-SY", "ar-JO", "ar-LB", "ar-KW", "ar-AE", "ar-BH", "ar-QA"],
    en: ["en"]
}

export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour:'2-digit',
    minute:'2-digit',
    second:'2-digit',
    timeZoneName: 'short',
    hourCycle:'h23'
}

export const PAGE_HEADERS = {
    INDUCT: {
        tab: "induct.tabHeading",
        tabAlt: "Sort",
        head: "induct.heading",
        headAlt: "Induct",
        desc: "induct.description",
        descAlt: "This page shows the status, cycle, and number of containers and packages in the induct process"
    },
    RECEIVE: {
        tab: "receive.tabHeading",
        tabAlt: "Receive",
        head: "receive.heading",
        headAlt: "Receive",
        desc: "receive.description",
        descAlt: "This table shows the status, cycle, and number of containers and packages in the receive process"
    },
    ASSOCIATE: {
        tab: "dwell.tabHeading",
        tabAlt: "Associates",
        head: "associate.heading",
        headAlt: "Induct associates",
        desc: "associate.description",
        descAlt: "This table shows induct associates’ performance data and current working location"
    },
    INDUCT_MANAGEMENT: {
        tab: "inductmanagement.tabHeading",
        tabAlt: "Sort",
        head: "inductmanagement.heading",
        headAlt: "Induct management",
        desc: "inductmanagement.description",
        descAlt: "This page helps you manage the cycles for induct and force-induct"
    },
    INBOUND: {
        tab: "inbound.tabHeading",
        tabAlt: "Inbound",
        head: "inbound.heading",
        headAlt: "Inbound",
        desc: "inbound.description",
        descAlt: "This page shows inbound operations and metrics"
    }
}

export const METRIC = {
    GET_MHE_LOCATION_DATA: "getMHELocationData"
}

export const INBOUND_ACTION_TYPES = {
    LOAD_INBOUND_DATA: "LOAD_INBOUND_DATA",
    RECEIVE_PPH_DATA: "RECEIVE_PPH_DATA",
    RECEIVE_DOWNTIME_DATA: "RECEIVE_DOWNTIME_DATA",
    RECEIVE_QUALITY_DATA: "RECEIVE_QUALITY_DATA",
    QUALITY_DATA_FAILURE: "QUALITY_DATA_FAILURE",
    RECEIVE_STOW_METRICS: "RECEIVE_STOW_METRICS",
    STOW_METRICS_FAILURE: "STOW_METRICS_FAILURE",
    RECEIVE_CUBE_METRICS: "RECEIVE_CUBE_METRICS",
    CUBE_METRICS_FAILURE: "CUBE_METRICS_FAILURE",
    CUBE_METRICS_UNAVAILABLE: "CUBE_METRICS_UNAVAILABLE",
    API_FAILURE: "API_FAILURE",
    CLEAR_DATA: "CLEAR_DATA"
}

// Metric names the Cube Analysis section renders. Owned by the caller, not the API layer.
export const CUBE_METRIC_NAMES = [
    "PENDING_DEPART_CUBE",
    "IN_TRANSIT_CUBE",
    "PENDING_INDUCT_CUBE",
    "PENDING_STOW_CUBE",
    "STOW_CUBE"
]

export const INBOUND_STRINGS = {
    DATA_TABLE_VIEW: "Data Table View",
    CLOSE: "Close",
    TIME: "Time",
    ACTUAL_PPH: "Actual PPH",
    ACTUAL_PACKAGES: "Actual Packages",
    PACKAGES_SUFFIX: " packages",
    UNKNOWN: "Unknown",
    PPH_SUFFIX: " PPH",
    HOURS_SUFFIX: "h",
    SUBTITLE_PACKAGES_PER_HOUR: "Packages Per Hour (All Lines)",
    SUBTITLE_CUMULATIVE_DOWNTIME: "Cumulative Downtime",
    SUBTITLE_DEFECTS_PER_MILLION: "Defects Per Million Opportunities",
    ERROR_FETCH_PPH: "Failed to fetch Inbound PPH data",
    ERROR_FETCH_DOWNTIME: "Failed to fetch Inbound Downtime data",
    ERROR_FETCH_STOW_METRICS: "Failed to fetch Stow metrics data",
    TOOLTIP_TOTAL_FPH: "inbound.tooltip.total_fph",
    TOOLTIP_LOST_HOURS: "inbound.tooltip.lost_hours",
    TOOLTIP_INDUCT_DT_DPMO: "inbound.tooltip.induct_dt_dpmo",
    TOOLTIP_QUALITY_METRICS: "inbound.tooltip.quality_metrics",
    TOOLTIP_STOW_FPH: "tooltip.stow.stowFPH",
    TOOLTIP_STOW_WIP_COMPLIANCE: "tooltip.stow.stowWipCompliance",
    TOOLTIP_STOW_WIP: "tooltip.stow.stowWIP",
    TOOLTIP_STOW_METRICS_SECTION: "tooltip.stow.stowMetricsSection",
    POLICY_URL_FPH: "https://policy.a2z.com/docs/682730/publication",
    POLICY_URL_LOST_HOURS: "https://policy.a2z.com/docs/668578/publication",
    POLICY_URL_DPMO: "https://policy.a2z.com/docs/668602/publication",
    POLICY_URL_QUALITY: "https://policy.a2z.com/docs/690162/publication",
    ERROR_FETCH_QUALITY_METRICS: "Failed to fetch quality metrics data",
    ERROR_FETCH_CUBE_METRICS: "Failed to fetch Cube metrics data"
}

export const STOW_WIP_PRECISION = 1;
export const STOW_WIP_LOWER = 15.0;
export const STOW_WIP_UPPER = 30.0;
export const WIP_TARGET = 70.0;

export const QUALITY_THRESHOLDS = {
    MISAPPLIED_SAL: { critical: 1.0 },
    MULTI_READ: { critical: 1.0 },
    NO_READ: { critical: 1.0 }
};

export const QUALITY_ISSUE_LABELS = {
    MISAPPLIED_SAL: 'Misapplied SAL',
    MULTI_READ: 'Multi-read',
    NO_READ: 'No-read'
};

export const PERFORMANCE_BAR = {
    MAX_SCALE: 150,
    HALF_SCALE: 50,
    BENCHMARK: 100,
    EXCELLENT_THRESHOLD: 100,
    WARNING_THRESHOLD: 80
}

export const TREND_CHART_COLORS = {
    LINE: '#0073BB',
    LINE_FILL: 'rgba(0, 115, 187, 0.1)',
    POINT_BORDER: '#FFFFFF',
    TICK_FONT: '#6B6B6B',
    GRID_LINE: '#E6E6E6',
    TOOLTIP_BG: 'rgba(0, 0, 0, 0.8)'
}

export const TIME_SERIES_GRANULARITY_MINUTES = 15;
export const DEFAULT_TIME_RANGE_MS = 6 * HOUR_MILLISECONDS;

export const ASL_PREFIX = 'ASL';
export const PACKAGE_SIZE = 'PackageSize';
export const CYCLE = 'Cycle';
export const CLUSTER = 'Cluster';
export const XS = 'XS';
export const S = 'S';
export const M = 'M';
export const L = 'L';
export const XL = 'XL';
export const NC = 'XXL(NC)';
export const VOLUME = 'Volume';
export const FMC = 'FMC';
export const EXTRA_SMALL = 'EXTRA_SMALL';
export const SMALL = 'SMALL';
export const MEDIUM = 'MEDIUM';
export const LARGE = 'LARGE';
export const EXTRA_LARGE = 'EXTRA_LARGE';
export const HEAVY_BULKY_NON_CON = 'HEAVY_BULKY_NON_CON';
export const INDUCT_MANAGEMENT_PERMISSIONS_REGION = ["US", "EU", "FE", "IN"];
export const FORCE_INDUCT_ROLE = ["Station Settings Manager"];
export const ROOT_STATIONS = {
    US: ["US_ROOT", "BR_ROOT", "MX_ROOT", "CA_ROOT"],
    EU: [
        "AE_ROOT",
        "AMZN_DE",
        "AMZN_ES",
        "AMZN_IT",
        "AMZN_FR",
        "AMZN_AT",
        "AMZN_UK",
        "AMZN_IE",
        "SA_ROOT",
        "EG_ROOT",
        "TR_ROOT",
        "BE_ROOT",
        "NL_ROOT",
    ],
    FE: ["JP_AMZL_ROOT", "AU_ROOT", "SG_ROOT"],
    IN: ["IN_ROOT"],
};





// WEBPACK FOOTER //
// ./src/components/util/Constants.js